<template>
  <div class="container">
    <div class="card mx-auto mt-5">
      <div class="card-header">
        <strong>{{ $t('brand') }}</strong> - {{ $t('authentification.emailConfirmationTitle') }} 
      </div>
      <div class="card-body">        
        <p>{{$t('authentification.confirmEmailInstructions')}}</p>
        <hr class="mt-4 mb-4">

        <errorMessage v-bind:message="error"></errorMessage>
        <password-input v-bind:action="changePasswordAction"></password-input>
        
      </div>
    </div>
  </div>
</template>

<script>
import {TokenAuthServiceClient, UserConfirmationModel} from '../shared/service-clients/service-clients'
import ServiceFactory from '../shared/service-clients/serviceClientFactory'
import ErrorMessage from './ErrorMessage.vue'
import CrudMixin from '../shared/Mixin/CrudMixin'
import PasswordInput from '../shared/components/PasswordInput.vue'

export default {
  name: 'email-confirmation',
  mixins: [CrudMixin],
  data() {
    let self = this

    let changePasswordAction = function(clean) {
      let emailConfirmationCode = self.$route.params.code
      let tokenAuthService = ServiceFactory.create(TokenAuthServiceClient)

      tokenAuthService
        .confirmUser(
          new UserConfirmationModel({
            password: this.password,
            emailConfirmationCode: emailConfirmationCode,
          })
        )
        .then(res => {
          clean()
          this.$swal('Succès', 'Compte activé', 'success')
          this.$router.push({path: '/login'})
        })
        .catch(err => {
          self.processError(err, self)
        })
    }

    return {
      error: '',
      changePasswordAction: changePasswordAction,
    }
  },
  created: function() {},
  methods: {
    fetchData: function() {},
  },
  components: {
    errorMessage: ErrorMessage,
    'password-input': PasswordInput,
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>



// WEBPACK FOOTER //
// src/components/EmailConfirmation.vue